import { h } from 'preact';
import * as BaseComp from 'components/bolt/hub/components/carousel/carousel.js';
import s from 'components/bolt/hub/components/carousel/carousel.sss';
import { findInVNode } from 'utils/vnode';

export default class Carousel extends BaseComp.default {
	render(props) {
		const baseJSX = super.render(props);
		const carousel = findInVNode(baseJSX, `.${s.carousel}`);
		const tiles = carousel.children;
		tiles.forEach(tile => {
			if (props.data.isCategory) {
				tile.attributes.isCategory = true;
			}
		});
		return baseJSX;
	}
}
